module.exports = __webpack_public_path__ + "img/miandian.9470d861.jpg";